export class ModalConfig {
  showOrderPincode?: boolean;
  showOrderConditions: boolean;
  showFaq: boolean;
  showTAndC?: boolean;
  showOrderSucceeded: boolean;
  showOrderFailed: boolean;
  showOrderMessage: boolean;
  showTrialCode?: boolean;
  showFindTrialCode?: boolean;
  showTrialSuccess?: boolean;
  showTrialComparison?: boolean;
  showTrialPending?: boolean;
  showTrialAttemptsReached?: boolean;
  showLogo?: boolean;
  showHintInfoKey?: boolean;
}
